import { render, staticRenderFns } from "./password3.vue?vue&type=template&id=197ef681&"
import script from "./password3.vue?vue&type=script&lang=js&"
export * from "./password3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports